import VueRouter, { Route } from 'vue-router';

export default new VueRouter({
  base: 'mi-mudanza',
  mode: 'history',
  scrollBehavior(_to: Route, _from: Route, savedPosition) {
    if (savedPosition) return savedPosition;
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/:id_mm?',
      component: () => import('views/pro/clientes/panel-cliente/lista-cotizaciones.vue'),
      props: true,
    },
    {
      path: '/inventario/:id_mm?',
      component: () => import('views/pro/clientes/panel-cliente/views/informacion_solicitud.vue'),
      props: true,
    },
    {
      path: '/detalle/:id_mm?',
      component: () => import('views/pro/clientes/panel-cliente/views/detalle-precio.vue'),
      props: true,
    },
  ],
});
